<template>
	<div class="o-container o-container--thin onboarding-page offers-page">
		<my-offers-form :user="user" />
	</div>
</template>

<script>
    import MyOffersForm from '../forms/MyOffersForm.vue';
    import { mapState } from 'vuex';

    export default {
        components: {
            MyOffersForm
        },
        computed: {
            ...mapState('user', {
                user: state => state.user
            })
        }
    }
</script>
